import { render, staticRenderFns } from "./CustomersReportsNeopag.vue?vue&type=template&id=d253586c&scoped=true&"
import script from "./CustomersReportsNeopag.vue?vue&type=script&lang=js&"
export * from "./CustomersReportsNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d253586c",
  null
  
)

export default component.exports